
import { defineComponent, ref, computed } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { state, dispatch } = useStore()
    const showText = ref("")
    const carNumber = computed(() => state.complete.car)

    dispatch("complete/classify", [
      "운전자에게\n다이렉트 호출을 보냈습니다.",
      "운전자와\n직접 통화를 연결합니다.",
      "운전자와 대화할 수 있는\n링크를 문자로 보내드렸습니다.",
      "운전자를 호출했습니다.",
    ]).then((data) => {
      showText.value = data
    })
    return {
      carNumber,
      showText,
    }
  },
})
